import { getCookie, env, removeCookie } from '@forchange/utils';
import axios from 'axios';

export function getDomain(url: string, subdomain?: boolean) {
  const _subdomain = subdomain || false;

  let _url = url.replace(/(https?:\/\/)?(www.)?/i, '');

  if (!_subdomain) {
    const urlAry = _url.split('.');

    _url = urlAry.slice(urlAry.length - 2).join('.');
  }

  if (_url.indexOf('/') !== -1) {
    return _url.split('/')[0];
  }

  return _url;
}

export async function getFcToken() {
  try {
    const sandboxServer = env.isProd() ? 'https://cleword.cn/biz' : 'https://test.cleword.cn/biz';
    const token = getCookie('token');
    if (token) {
      removeCookie('token', {
        domain: '.cleword.cn'
      });
    }

    const clewordToken = getCookie('cleword_token');
    const instance = axios.create({
      headers: { Authorization: `Bearer ${clewordToken}` },
      withCredentials: true
    });
    // 拿课灵token 获取 沙盒用户体系cookie,set cookie（http-only） 到根域名
    await instance.post(`${sandboxServer}/callback-authing/signin/v1/fc`);
  } catch (e) {
    console.error('获取 v3 token 失败', e);
    // throw new Error('获取 v3 token 失败', e);
  }
}

export async function setDocumentTitle(title: string) {
  document.title = title;
  const user = navigator.userAgent.toLowerCase();
  if (user.indexOf('dingtalk') !== -1) {
    const dd = await import('dingtalk-jsapi');
    dd.biz.navigation.setTitle({
      title
    });
  }
}

export function getClientIsMobile() {
  if (
    window.navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return true;
  } else {
    return false;
  }
}
